export default __webpack_public_path__ + "images/VWTextCarUI-Regular.2cfffdb7.ttf";